import { Product } from '../types';

// ============================================
// FUSE BOXES
// ============================================
export const fuseBoxProducts: Product[] = [
  {
    id: "fb-1",
    name: "Square Fuse Box",
    slug: "square-fuse-box",
    category: "Fuse Box",
    subcategory: "Universal",
    description: "Universal square fuse box for blade fuses. Available in multiple configurations.",
    specifications: {
      "Type": "Square",
      "Fuse Type": "Blade",
      "Variants": "Multiple configurations",
    },
    tags: ["fuse-box", "square", "universal"],
    applications: ["Automotive", "Commercial Vehicles"],
  },
  {
    id: "fb-2",
    name: "Eicher Canter Fuse Box",
    slug: "eicher-canter-fuse-box",
    category: "Fuse Box",
    subcategory: "Eicher",
    description: "Fuse box compatible with Eicher Canter trucks. Universal fit for models 10.11, 10.50 Pro, 10.59, 10.69, 10.75, 10.90, 10.95, 11.10, 30.25 Galaxy, Jumbo.",
    partNumber: "SFB5151C",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5151C.jpg",
    specifications: {
      "Compatible": "Eicher Canter",
      "Models": "10.11, 10.50 Pro, 10.59, 10.69, 10.75, 10.90, 10.95, 11.10, 30.25 Galaxy, Jumbo",
      "Configuration": "30 Wire + 20 Point",
      "Compliance": "BS II, BS III, BS IV",
    },
    tags: ["fuse-box", "eicher", "canter"],
    applications: ["Commercial Vehicles", "Trucks"],
  },
  {
    id: "fb-3",
    name: "Ashok Leyland Fuse Box",
    slug: "ashok-leyland-fuse-box",
    category: "Fuse Box",
    subcategory: "Ashok Leyland",
    description: "Fuse box for Ashok Leyland commercial vehicles. Multiple configurations available.",
    featured: true,
    specifications: {
      "Compatible": "Ashok Leyland",
      "Variants": "Multiple models",
    },
    tags: ["fuse-box", "ashok-leyland"],
    applications: ["Commercial Vehicles", "Trucks"],
  },
  {
    id: "fb-4",
    name: "Maruti Fuse Box - Car Type",
    slug: "maruti-fuse-box-car",
    category: "Fuse Box",
    subcategory: "Maruti",
    description: "Fuse box for Maruti cars. Compatible with Type I, Type II, Type III, Gypsy King.",
    partNumber: "SFB5401M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5401M.jpg",
    featured: true,
    specifications: {
      "Compatible": "Maruti Cars",
      "Type": "Car Type",
      "Models": "Type I, Type II, Type III, Gypsy King",
      "Configuration": "17 Wire, 18 Point, With Flasher",
    },
    tags: ["fuse-box", "maruti", "car"],
    applications: ["Passenger Cars"],
  },
  {
    id: "fb-5",
    name: "Maruti Fuse Box - Van Type",
    slug: "maruti-fuse-box-van",
    category: "Fuse Box",
    subcategory: "Maruti",
    description: "Fuse box for Maruti Omni and vans. Type I, Type II, Type III with flasher and AC fuse.",
    partNumber: "SFB7205V",
    specifications: {
      "Compatible": "Maruti Vans",
      "Type": "Van Type",
      "Models": "Omni, Type I, Type II, Type III",
      "Configuration": "14 Wire, 12 Point, With Flasher, AC Fuse",
    },
    tags: ["fuse-box", "maruti", "van"],
    applications: ["Commercial Vans"],
  },
  {
    id: "fb-6",
    name: "Glass Fuse Box",
    slug: "glass-fuse-box",
    category: "Fuse Box",
    subcategory: "Glass Fuse",
    description: "Fuse box for glass tube fuses. Available in 6, 8, 10 pole configurations.",
    specifications: {
      "Fuse Type": "Glass Tube",
      "Poles": "6, 8, 10",
    },
    tags: ["fuse-box", "glass", "tube"],
    applications: ["Automotive", "Vintage Vehicles"],
  },
  {
    id: "fb-7",
    name: "JCB Fuse Box",
    slug: "jcb-fuse-box",
    category: "Fuse Box",
    subcategory: "JCB",
    description: "Heavy-duty fuse box for JCB machinery. Available in small, medium, and big configurations.",
    featured: true,
    specifications: {
      "Compatible": "JCB Equipment",
      "Type": "Heavy Duty",
      "Variants": "12 Pole Small, 28 Pole Medium, 48 Pole Big",
    },
    tags: ["fuse-box", "jcb", "heavy-duty"],
    applications: ["Heavy Machinery", "JCB Equipment"],
  },
  {
    id: "fb-8",
    name: "Tata Indica Fuse Box",
    slug: "tata-indica-fuse-box",
    category: "Fuse Box",
    subcategory: "Tata",
    description: "Universal Tata Indica Diesel fuse box with 60A fuse and deluxe wire.",
    specifications: {
      "Compatible": "Tata Indica Diesel",
      "Fuse Rating": "60A",
      "Wire": "8mm, 10mm Deluxe",
    },
    tags: ["fuse-box", "tata", "indica"],
    applications: ["Passenger Cars"],
  },
  {
    id: "fb-9",
    name: "Mahindra Bolero Fuse Box",
    slug: "mahindra-bolero-fuse-box",
    category: "Fuse Box",
    subcategory: "Mahindra",
    description: "Mini fuse box for Mahindra Bolero Camper with 4 relay configuration.",
    partNumber: "SFB5415M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5415M.jpg",
    specifications: {
      "Compatible": "Mahindra Bolero Camper",
      "Type": "MDI TC BS II, BS III, BS IV",
      "Relays": "4",
      "Points": "40",
      "Configuration": "18 Wire, 24 Point, 3 Socket, With Flasher",
    },
    tags: ["fuse-box", "mahindra", "bolero"],
    applications: ["SUVs", "Utility Vehicles"],
  },
  {
    id: "fb-10",
    name: "Tata Sumo Fuse Box",
    slug: "tata-sumo-fuse-box",
    category: "Fuse Box",
    subcategory: "Tata",
    description: "Universal fuse box for Tata Sumo, Sumo Deluxe models.",
    partNumber: "SFB5422M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5422M.jpg",
    specifications: {
      "Compatible": "Tata Sumo, Sumo Deluxe, 1613 TC, 2515 TC, 2518 TC, 407, 709, 1109 Turbo",
      "Configuration": "23 Wire, 28 Point",
    },
    tags: ["fuse-box", "tata", "sumo"],
    applications: ["SUVs", "Commercial Vehicles"],
  },
  {
    id: "fb-11",
    name: "Tata ACE Fuse Box",
    slug: "tata-ace-fuse-box",
    category: "Fuse Box",
    subcategory: "Tata",
    description: "Fuse box for Tata ACE BS II, BS III & BS IV, Magic.",
    partNumber: "SFB5432M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5432M.jpg",
    featured: true,
    specifications: {
      "Compatible": "Tata ACE, Magic",
      "Configuration": "20 Wire, 26 Point",
      "Compliance": "BS II, BS III, BS IV",
    },
    tags: ["fuse-box", "tata", "ace"],
    applications: ["Light Commercial Vehicles"],
  },
  {
    id: "fb-12",
    name: "Mahindra Maximo Fuse Box",
    slug: "mahindra-maximo-fuse-box",
    category: "Fuse Box",
    subcategory: "Mahindra",
    description: "Mini fuse box for Mahindra Maximo with 5mm & 6mm deluxe wire.",
    partNumber: "SFB9021",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB9021.jpg",
    specifications: {
      "Compatible": "Mahindra Maximo",
      "Configuration": "46 Wire",
      "Wire": "5mm & 6mm Deluxe",
    },
    tags: ["fuse-box", "mahindra", "maximo"],
    applications: ["Small Commercial Vehicles"],
  },
  {
    id: "fb-13",
    name: "Tata 407/LPT Fuse Box",
    slug: "tata-407-lpt-fuse-box",
    category: "Fuse Box",
    subcategory: "Tata",
    description: "Square fuse box suitable for Tata LPT series trucks (1613TC, 1616TC, 2515TC, 2518TC, 3118TC, 3718TC, 4018TC, 4018 Horse).",
    partNumber: "SFB5101S",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5101S.jpg",
    specifications: {
      "Compatible": "Tata LPT Series",
      "Models": "1613TC, 1616TC, 2515TC, 2518TC, 3118TC, 3718TC, 4018TC, 4018 Horse",
      "Configuration": "60 Wire (60 Point), 14 Relay (56 Wire)",
      "Compliance": "BS II, BS III, BS IV",
    },
    tags: ["fuse-box", "tata", "lpt", "407"],
    applications: ["Medium/Heavy Commercial Vehicles"],
  },
  {
    id: "fb-14",
    name: "Mahindra Jeep Fuse Box",
    slug: "mahindra-jeep-fuse-box",
    category: "Fuse Box",
    subcategory: "Mahindra",
    description: "Universal fuse box for Mahindra Jeep, Bolero, Pick-up Utility Savari.",
    partNumber: "SFB5418M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5418M.jpg",
    specifications: {
      "Compatible": "Mahindra Jeep, Bolero, Pick-up Utility Savari",
      "Configuration": "17 Wire, 24 Point",
      "Compliance": "BS II, BS III, BS IV",
    },
    tags: ["fuse-box", "mahindra", "jeep"],
    applications: ["SUVs", "Utility Vehicles"],
  },
  {
    id: "fb-15",
    name: "Tata Sumo 207 DI Fuse Box",
    slug: "tata-sumo-207-di-fuse-box",
    category: "Fuse Box",
    subcategory: "Tata",
    description: "Universal fuse box for Tata Sumo 207 DI / 207 2005 DI / 207 DI Turbo / Sumo Spacio.",
    partNumber: "SFB5428M",
    image: "/products/fuse-boxes-complete/universal-fuse-box/SFB5428M.jpg",
    specifications: {
      "Compatible": "Tata Sumo 207 DI, 207 2005 DI, 207 DI Turbo, Sumo Spacio",
      "Configuration": "32 Wire, 32 Point, 2 Pcs AC Fuse Dibbi",
      "Compliance": "BS II, BS III",
    },
    tags: ["fuse-box", "tata", "sumo", "207di"],
    applications: ["SUVs"],
  },
];
